// extracted by mini-css-extract-plugin
export default {"bell-icon":"CampaignPopUp_bell-icon__KcfhG","title":"CampaignPopUp_title__ub7Rt","alert":"CampaignPopUp_alert__ZR9ba","close-btn":"CampaignPopUp_close-btn__23Zzt"};